import {
    apiRequest,
    excludeAbsenDetail
} from "../../../../../services/adapters/kepegawaian/excludeAbsenService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", excludeAbsenDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository